module.exports = __webpack_public_path__ + "static/mypic-ee56616eca1346e4024eb39fc2ac0a0e.jpg";